/**
 * Twin shares' public operations (docs/specs/twin-shares.md, section 7), part of TWIN_PUBLIC_OPERATIONS. All are called
 * as the person; none has an MCP tool. Read state and Inbox state count as writes, as `twin.feed.mark-read` does.
 */
export const TWIN_SHARE_OPERATIONS = {
    listShares: { operationId: "twin.shares.list", method: "GET", path: "/api/twin/shares", requiredScope: "twin.read" },
    createShare: { operationId: "twin.shares.create", method: "POST", path: "/api/twin/shares", requiredScope: "twin.write" },
    getShare: { operationId: "twin.shares.get", method: "GET", path: "/api/twin/shares/{shareId}", requiredScope: "twin.read" },
    updateShare: { operationId: "twin.shares.update", method: "PATCH", path: "/api/twin/shares/{shareId}",
        requiredScope: "twin.write" },
    deleteShare: { operationId: "twin.shares.delete", method: "DELETE", path: "/api/twin/shares/{shareId}",
        requiredScope: "twin.write" },
    moveShare: { operationId: "twin.shares.move", method: "POST", path: "/api/twin/shares/{shareId}/move",
        requiredScope: "twin.write" },
    setShareInboxState: { operationId: "twin.shares.inbox-state.set", method: "PUT",
        path: "/api/twin/shares/{shareId}/inbox-state", requiredScope: "twin.write" },
    addSharePeople: { operationId: "twin.share-people.add", method: "POST", path: "/api/twin/shares/{shareId}/people",
        requiredScope: "twin.write" },
    removeSharePerson: { operationId: "twin.share-people.remove", method: "DELETE",
        path: "/api/twin/shares/{shareId}/people/{userId}", requiredScope: "twin.write" },
    getShareThread: { operationId: "twin.share-threads.get", method: "GET", path: "/api/twin/shares/{shareId}/thread",
        requiredScope: "twin.read" },
    createShareComment: { operationId: "twin.share-comments.create", method: "POST",
        path: "/api/twin/shares/{shareId}/thread/comments", requiredScope: "twin.write" },
    updateShareComment: { operationId: "twin.share-comments.update", method: "PATCH",
        path: "/api/twin/shares/{shareId}/thread/comments/{commentId}", requiredScope: "twin.write" },
    deleteShareComment: { operationId: "twin.share-comments.delete", method: "DELETE",
        path: "/api/twin/shares/{shareId}/thread/comments/{commentId}", requiredScope: "twin.write" },
    setShareReaction: { operationId: "twin.share-reactions.set", method: "POST",
        path: "/api/twin/shares/{shareId}/thread/reactions", requiredScope: "twin.write" },
    setShareThreadReadState: { operationId: "twin.share-read-state.set", method: "POST",
        path: "/api/twin/shares/{shareId}/thread/read-state", requiredScope: "twin.write" },
    getShareFileContent: { operationId: "twin.share-files.content", method: "GET",
        path: "/api/twin/shares/{shareId}/files/{fileId}/content", requiredScope: "twin.read" },
};
